module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAT1JREFUaEPtlj1OAlEUhc8jYlQKXYIFIRkLCqcY9+EmTLRzB9K7Ae0pWMSUhBh+uiExxnWgMtcQQzIBoTlP4SZn+nveu99333sT4PwLzvcPNbBrgzIgAyQBjRAJkC6XARohGSADJEC6XAZohGSADJAA6XIZ2IYwNztojKcPVuIONTxll8k9jXwl4M8M9MfFea1EF8DVz5r2laUXdRcNvIyK69LsGQhn1Q1naRIdWNTAPH8/OjmdPQbgxszWsve6gcHkrYX5Rw9Ae9OY7HcDw+IVQHPbjKuBX+hEOwODSdHCHH5HaAHH9SGu2nV7jVabWH/I8JmlyaGLh2y5ycWvxPFw2gkBtwjOfiVik96UF+0W+q8Nr66jBnZFfrmuDMgASUAjRAKky2WARkgGyAAJkC6XARohGSADJEC63L2Bb/ubTjElNnBfAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/imgs/land21.png
// module id = 7HjH
// module chunks = 0